import { render, staticRenderFns } from "./tabpage.vue?vue&type=template&id=6a6d1411&"
import script from "./tabpage.vue?vue&type=script&lang=js&"
export * from "./tabpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports